import { BaseCanvasPack } from "./BaseCanvasPack";

export default class LavaCanvasPack extends BaseCanvasPack {
  drawBackground(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number,
    level?: number
  ): void {
    const gradient = context.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, "#4a0404");
    gradient.addColorStop(0.5, "#b71c1c");
    gradient.addColorStop(1, "#090303");
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);

    if (frameTime !== undefined) {
      this.drawLavaStreams(context, width, height, frameTime);
    }
  }

  drawFrame(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {

    // Cracked rock border
    const borderWidth = 4;
    context.strokeStyle = "#3E2723"; // Dark rock
    context.lineWidth = borderWidth;
    context.strokeRect(borderWidth/2, borderWidth/2, width - borderWidth, height - borderWidth);
    
    // Inner glow (heat)
    context.shadowColor = "#FF5722";
    context.shadowBlur = 15;
    context.strokeRect(borderWidth/2, borderWidth/2, width - borderWidth, height - borderWidth);
    context.shadowBlur = 0;
  }

  drawOverlay(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {
    if (frameTime !== undefined) {
      this.drawSmoke(context, width, height, frameTime);
      this.drawEmbers(context, width, height, frameTime);
    }
  }

  private drawLavaStreams(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    // Slow moving lava texture
    
    const gradient = context.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, "rgba(255, 87, 34, 0.1)");
    gradient.addColorStop(0.5, "rgba(183, 28, 28, 0.2)");
    gradient.addColorStop(1, "rgba(255, 87, 34, 0.1)");
    
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);
    
    context.restore();
  }

  private drawSmoke(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    const count = 10;
    for (let i = 0; i < count; i++) {
      const seed = i * 99.9;
      const speed = 0.02;
      const x = (Math.sin(seed) * width + Math.sin(frameTime * 0.0005 + seed) * 20 + width) % width;
      const y = (height - (frameTime * speed + seed * 100) % height);
      const size = 10 + Math.sin(frameTime * 0.001 + seed) * 5;
      
      context.fillStyle = `rgba(50, 50, 50, ${0.3 * (y / height)})`; // Fade out at top
      context.beginPath();
      context.arc(x, y, size, 0, Math.PI * 2);
      context.fill();
    }
    context.restore();
  }

  private drawEmbers(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    const count = 20;
    for (let i = 0; i < count; i++) {
      const seed = i * 44.4;
      const speed = 0.05 + Math.sin(seed) * 0.02;
      const x = (Math.cos(seed) * width + Math.sin(frameTime * 0.002 + seed) * 10 + width) % width;
      const y = (height - (frameTime * speed + seed * 50) % height);
      
      context.fillStyle = i % 2 === 0 ? "#FFC107" : "#FF5722";
      context.globalAlpha = Math.sin(frameTime * 0.01 + seed) * 0.5 + 0.5;
      
      context.beginPath();
      context.arc(x, y, 1.5, 0, Math.PI * 2);
      context.fill();
    }
    context.restore();
  }

  getBorderStyle(): string {
    return "4px solid #3E2723";
  }

  getBoxShadow(frameTime?: number): string {
    let pulse = 0.5;
    if (frameTime !== undefined) {
      pulse = 0.5 + 0.2 * Math.sin(frameTime * 0.003);
    }
    return `0 0 30px rgba(255, 87, 34, ${pulse})`;
  }

  getBackdropFilter(): string {
    return "blur(1px) contrast(1.2)";
  }
}

